var getElementOuterHeight = function getElementOuterHeight(element) {
  var _window$getComputedSt = window.getComputedStyle(element),
      marginTop = _window$getComputedSt.marginTop,
      marginBottom = _window$getComputedSt.marginBottom;

  var elementMargins = parseFloat(marginTop) + parseFloat(marginBottom);
  return element.offsetHeight + elementMargins;
};

export default getElementOuterHeight;